import * as React from "react";
import type { SVGProps } from "react";
const SvgInstagram = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="currentColor" clipPath="url(#instagram_svg__a)">
      <path d="M18 22H6c-2.21 0-4-1.79-4-4V6c0-2.21 1.79-4 4-4h12c2.21 0 4 1.79 4 4v12c0 2.21-1.79 4-4 4M6 4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2z" />
      <path d="M12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5m0-8c-1.65 0-3 1.35-3 3s1.35 3 3 3 3-1.35 3-3-1.35-3-3-3M17 8c-.06 0-.13-.01-.19-.02a.6.6 0 0 1-.19-.06.6.6 0 0 1-.17-.09c-.06-.03-.11-.08-.16-.12-.18-.19-.29-.45-.29-.71s.11-.52.29-.71c.05-.04.1-.08.16-.12.05-.04.11-.07.17-.09.06-.03.12-.05.19-.06.33-.06.67.04.9.27.04.05.09.1.12.16.04.05.07.11.09.17q.045.09.06.18c.01.07.02.13.02.2 0 .26-.11.52-.29.71-.19.18-.45.29-.71.29" />
    </g>
    <defs>
      <clipPath id="instagram_svg__a">
        <path fill="#fff" d="M2 2h20v20H2z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgInstagram;
